import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setToken } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    if (!localStorage.getItem("dbr_token")) {
      setUser(false);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    setToken(data.token);
    setUser(data.user);
  };
  const logout = () => {
    setToken(null);
    setUser(false);
  };
  const bump = useCallback(() => setVersion((v) => v + 1), []);

  return <AuthCtx.Provider value={{ user, login, logout, version, bump }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
